var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInsuranceInactive = function SvgInsuranceInactive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_97)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8335 2.91671C5.8335 1.76611 6.76624 0.833374 7.91683 0.833374H17.0835C18.2341 0.833374 19.1668 1.76611 19.1668 2.91671V15.8334C19.1668 17.6743 17.6744 19.1667 15.8335 19.1667H7.91683C6.76624 19.1667 5.8335 18.234 5.8335 17.0834V2.91671ZM7.91683 2.50004C7.68671 2.50004 7.50016 2.68659 7.50016 2.91671V17.0834C7.50016 17.3135 7.68671 17.5 7.91683 17.5H15.8335C16.754 17.5 17.5002 16.7538 17.5002 15.8334V2.91671C17.5002 2.68659 17.3136 2.50004 17.0835 2.50004H7.91683Z",
    fill: "#8390A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16699 5.41671C9.16699 4.95647 9.54009 4.58337 10.0003 4.58337H15.0003C15.4606 4.58337 15.8337 4.95647 15.8337 5.41671C15.8337 5.87694 15.4606 6.25004 15.0003 6.25004H10.0003C9.54009 6.25004 9.16699 5.87694 9.16699 5.41671Z",
    fill: "#8390A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16699 8.33333C9.16699 7.8731 9.54009 7.5 10.0003 7.5H12.5003C12.9606 7.5 13.3337 7.8731 13.3337 8.33333C13.3337 8.79357 12.9606 9.16667 12.5003 9.16667H10.0003C9.54009 9.16667 9.16699 8.79357 9.16699 8.33333Z",
    fill: "#8390A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91553 13.3334H12.0873C12.7735 13.3334 13.3337 13.8937 13.3337 14.585V15.8357C13.3337 17.2154 14.4542 18.3334 15.8365 18.3334H4.16978C2.78753 18.3334 1.66699 17.2156 1.66699 15.8341V14.5848C1.66699 13.8936 2.2297 13.3334 2.91553 13.3334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91537 14.1667C2.68996 14.1667 2.50016 14.3537 2.50016 14.5847V15.8341C2.50016 16.7539 3.24625 17.5 4.16962 17.5H12.9457C12.6624 17.0105 12.5002 16.4422 12.5002 15.8357V14.5849C12.5002 14.3515 12.3108 14.1667 12.0872 14.1667H2.91537ZM15.8363 17.5C14.9126 17.5 14.1668 16.7534 14.1668 15.8357V14.5849C14.1668 13.4358 13.236 12.5 12.0872 12.5H2.91537C1.76912 12.5 0.833496 13.4335 0.833496 14.5847V15.8341C0.833496 17.6771 2.32849 19.1667 4.16962 19.1667H15.8363C16.2965 19.1667 16.6696 18.7936 16.6696 18.3333C16.6696 17.8731 16.2965 17.5 15.8363 17.5Z",
    fill: "#8390A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInsuranceInactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/insurance-inactive.89883175.svg";
export { ForwardRef as ReactComponent };